export default __webpack_public_path__ + "static/media/04.dd66a0f6.jpg";